package com.eladfinish.bible.contest.screens.mikud.di

import com.eladfinish.bible.contest.screens.mikud.SyllabusCache
import com.eladfinish.bible.contest.screens.mikud.usecases.BuildBooksListUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.BuildMikudLevelsAnnotatedText
import com.eladfinish.bible.contest.screens.mikud.usecases.BuildMikudSummaryUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.ExtractMikudListUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetChaptersInMikudAsArrayListUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetChaptersInMikudUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetFilteredMikudListUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetMikudFromServerUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetMikudLevelInfoUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetRandomBookRandomChapterFilenameUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.GetRemoteMikudLevelInfoUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.ParseMikudFromFileUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.ParseMikudFromServerUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.ParseMikudUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.PickRandomChapterUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.PopulateBookUseCase
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val mikudModule = module {
    factoryOf(::BuildBooksListUseCase)
    factoryOf(::PopulateBookUseCase)
    factoryOf(::GetFilteredMikudListUseCase)
    factoryOf(::ParseMikudUseCase)
    factoryOf(::GetMikudFromServerUseCase)
    factoryOf(::BuildMikudSummaryUseCase)
    factoryOf(::GetMikudLevelInfoUseCase)
    factoryOf(::GetRemoteMikudLevelInfoUseCase)
    factoryOf(::SyllabusCache)
    factoryOf(::BuildMikudLevelsAnnotatedText)
    factoryOf(::PickRandomChapterUseCase)
    factoryOf(::GetRandomBookRandomChapterFilenameUseCase)
    factoryOf(::ExtractMikudListUseCase)
    factoryOf(::GetChaptersInMikudUseCase)
    factoryOf(::GetChaptersInMikudAsArrayListUseCase)
    factoryOf(::ParseMikudFromServerUseCase)
    factoryOf(::ParseMikudFromFileUseCase)
}
